import { Paragraph6EEGCreditResponseState } from "../../types/api.types";
import { CancellationState } from "../../utils/backend-types";
import { FinancialDocumentType } from "./Paragraph6.types";

export const FINANCIAL_DOCUMENT_TYPES = {
  [FinancialDocumentType.Credit]: "Gutschrift",
  [FinancialDocumentType.Cancellation]: "Stornierung",
  [FinancialDocumentType.PaymentInformation]: "Zahlungsinformationen"
} as const;

export const PARAGRAPH_6_INVOICE_STATE_OPTIONS = [
  {
    label: "Versandfertig",
    value: Paragraph6EEGCreditResponseState.ready_to_send
  },
  { label: "Versendet", value: Paragraph6EEGCreditResponseState.sent },
  { label: "Bezahlt", value: Paragraph6EEGCreditResponseState.paid }
];

export const PARAGRAPH_6_CANCELLATION_STATE_OPTIONS = [
  { label: "Versandfertig", value: CancellationState.ReadyToSend },
  { label: "Versendet", value: CancellationState.Sent },
  { label: "Erhalten", value: CancellationState.Received }
];

export const PARAGRAPH_6_TABS = {
  CONTRACTS: "vertraege",
  CREDITS: "gutschriften",
  CREDIT_NUMBER_RANGES: "gutschriftennummernkreise",
  PAYMENT_INFORMATION: "zahlungsinformationen"
} as const;
